import React from 'react';
import { Menu, X } from 'react-feather';
import logo from '../../assets/LogoBlackCropped.png';

const DocsHeader = ({ onStartChat, onToggleDrawer, mobileDrawerOpen }) => {
  const navItems = [
    { label: 'Overview', href: '/docs' },
    { label: 'Portal', href: '/agent' },
    { label: 'iOS Download', href: 'https://lauft.app', external: true },
    { label: 'Android Download', href: 'https://lauft.app', external: true }
  ];

  return (
    <header className="docs-header" style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      height: '64px',
      backgroundColor: '#ffffff',
      borderBottom: '1px solid rgba(0, 0, 0, 0.06)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0 32px',
      zIndex: 1000
    }}>
      {/* Left - Hamburger (mobile) + Logo + Nav */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '32px' }}>
        {/* Hamburger - mobile only */}
        <button
          className="docs-hamburger"
          onClick={onToggleDrawer}
          aria-label="Toggle navigation"
          style={{
            display: 'none',
            alignItems: 'center',
            justifyContent: 'center',
            width: '36px',
            height: '36px',
            backgroundColor: 'transparent',
            border: 'none',
            cursor: 'pointer',
            padding: 0,
            color: '#1a1a1a',
            borderRadius: '6px'
          }}
        >
          {mobileDrawerOpen ? <X size={22} /> : <Menu size={22} />}
        </button>

        <a
          href="/docs"
          style={{
            textDecoration: 'none',
            display: 'flex',
            alignItems: 'center'
          }}
        >
          <img
            src={logo}
            alt="Lauft"
            className="docs-header-logo"
            style={{
              height: '28px',
              width: 'auto'
            }}
          />
        </a>

        <nav className="docs-header-nav" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          {navItems.map((item) => (
            <a
              key={item.label}
              href={item.href}
              target={item.external ? '_blank' : undefined}
              rel={item.external ? 'noopener noreferrer' : undefined}
              style={{
                color: 'rgba(0, 0, 0, 0.7)',
                textDecoration: 'none',
                fontSize: '0.9rem',
                fontWeight: '500',
                padding: '8px 14px',
                borderRadius: '6px',
                transition: 'all 0.15s'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.color = '#1a1a1a';
                e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.04)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = 'rgba(0, 0, 0, 0.7)';
                e.currentTarget.style.backgroundColor = 'transparent';
              }}
            >
              {item.label}
            </a>
          ))}
        </nav>
      </div>

      {/* Right - Actions */}
      <div className="docs-header-actions" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <a
          href="https://calendly.com/team-lauft/support-general"
          target="_blank"
          rel="noopener noreferrer"
          className="docs-header-bookcall"
          style={{
            color: 'rgba(0, 0, 0, 0.7)',
            textDecoration: 'none',
            fontSize: '0.9rem',
            fontWeight: '500',
            padding: '8px 14px',
            borderRadius: '6px',
            transition: 'all 0.15s'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.color = '#1a1a1a';
            e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.04)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.color = 'rgba(0, 0, 0, 0.7)';
            e.currentTarget.style.backgroundColor = 'transparent';
          }}
        >
          Book Call
        </a>
        <button
          onClick={onStartChat}
          style={{
            backgroundColor: '#1a1a1a',
            color: '#ffffff',
            border: 'none',
            fontSize: '0.9rem',
            fontWeight: '500',
            padding: '10px 18px',
            borderRadius: '8px',
            cursor: 'pointer',
            transition: 'all 0.15s'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = '#333333';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = '#1a1a1a';
          }}
        >
          Start Chat
        </button>
      </div>

      {/* Mobile responsive overrides */}
      <style>{`
        @media (max-width: 768px) {
          .docs-header {
            height: 56px !important;
            padding: 0 16px !important;
          }
          .docs-hamburger {
            display: flex !important;
          }
          .docs-header-nav {
            display: none !important;
          }
          .docs-header-bookcall {
            display: none !important;
          }
          .docs-header-logo {
            height: 24px !important;
          }
        }
      `}</style>
    </header>
  );
};

export default DocsHeader;